/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MagicNameProjectMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  autoTriggered: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type MagicNameProjectMutation = {
  readonly __typename: "Mutation";
  readonly magicNameProject: string;
};

export type HexForProjectMetadataQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type HexForProjectMetadataQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly canEditMetadata: boolean;
  };
};

export const MagicNameProjectDocument = /*#__PURE__*/ gql`
  mutation MagicNameProject(
    $hexVersionId: HexVersionId!
    $autoTriggered: Boolean
  ) {
    magicNameProject(hexVersionId: $hexVersionId, autoTriggered: $autoTriggered)
  }
`;
export type MagicNameProjectMutationFn = Apollo.MutationFunction<
  MagicNameProjectMutation,
  MagicNameProjectMutationVariables
>;

/**
 * __useMagicNameProjectMutation__
 *
 * To run a mutation, you first call `useMagicNameProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicNameProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicNameProjectMutation, { data, loading, error }] = useMagicNameProjectMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      autoTriggered: // value for 'autoTriggered'
 *   },
 * });
 */
export function useMagicNameProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MagicNameProjectMutation,
    MagicNameProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MagicNameProjectMutation,
    MagicNameProjectMutationVariables
  >(MagicNameProjectDocument, options);
}
export type MagicNameProjectMutationHookResult = ReturnType<
  typeof useMagicNameProjectMutation
>;
export type MagicNameProjectMutationResult =
  Apollo.MutationResult<MagicNameProjectMutation>;
export type MagicNameProjectMutationOptions = Apollo.BaseMutationOptions<
  MagicNameProjectMutation,
  MagicNameProjectMutationVariables
>;
export const HexForProjectMetadataDocument = /*#__PURE__*/ gql`
  query HexForProjectMetadata($hexId: HexId!) {
    hexById(hexId: $hexId) {
      id
      canEditMetadata
    }
  }
`;

/**
 * __useHexForProjectMetadataQuery__
 *
 * To run a query within a React component, call `useHexForProjectMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHexForProjectMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHexForProjectMetadataQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useHexForProjectMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    HexForProjectMetadataQuery,
    HexForProjectMetadataQueryVariables
  > &
    (
      | { variables: HexForProjectMetadataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HexForProjectMetadataQuery,
    HexForProjectMetadataQueryVariables
  >(HexForProjectMetadataDocument, options);
}
export function useHexForProjectMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HexForProjectMetadataQuery,
    HexForProjectMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HexForProjectMetadataQuery,
    HexForProjectMetadataQueryVariables
  >(HexForProjectMetadataDocument, options);
}
export function useHexForProjectMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HexForProjectMetadataQuery,
    HexForProjectMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HexForProjectMetadataQuery,
    HexForProjectMetadataQueryVariables
  >(HexForProjectMetadataDocument, options);
}
export type HexForProjectMetadataQueryHookResult = ReturnType<
  typeof useHexForProjectMetadataQuery
>;
export type HexForProjectMetadataLazyQueryHookResult = ReturnType<
  typeof useHexForProjectMetadataLazyQuery
>;
export type HexForProjectMetadataSuspenseQueryHookResult = ReturnType<
  typeof useHexForProjectMetadataSuspenseQuery
>;
export type HexForProjectMetadataQueryResult = Apollo.QueryResult<
  HexForProjectMetadataQuery,
  HexForProjectMetadataQueryVariables
>;
